import { useEffect, useRef, useState } from "react";
import { useAppStore } from "@/hooks/useAppStore";
import { ChatMessageData, DisplayMessage, SystemMessageData } from "@/types";
import FireworksComponent from "./widgets/effects/FireworkLight";
import MeteorShowerCanvas from "./widgets/effects/MeteorShower";
import ConfettiCanvas from "./widgets/effects/Confetti";
import { WidgetRef } from "./widgets/type";
import { cn } from "@/lib/utils";

export default function WidgetWrapper() {
  const [isFullscreen] = useState(true);
  const roomId = useAppStore((state) => state.roomId);
  const isReady = useAppStore((state) => state.isReady);
  const messages = useAppStore((state) => state.messages);
  const translatedMessage = useAppStore((state) => state.translatedMessage);
  const lastSeenMessageId = useAppStore((state) => state.lastSeenMessageId);
  const setLastSeenMessageId = useAppStore((state) => state.setLastSeenMessageId);
  const isPresentationMode = useAppStore((state) => state.isPresentationMode);

  const widgetTargetRef = useRef<HTMLDivElement>(null);
  const fireworksEffectRef = useRef<WidgetRef>(null);
  const meteorEffectRef = useRef<WidgetRef>(null);
  const confettiEffectRef = useRef<WidgetRef>(null);

  const widgetsList: {
    ref: React.RefObject<WidgetRef | null>,
    callback: () => void,
    applicable: (msg: SystemMessageData | ChatMessageData) => boolean
  }[] = [{
    applicable: (msg: SystemMessageData | ChatMessageData) => {
      const messageText = (msg as ChatMessageData)?.translations?.en + " " + msg.message;
      if (msg.type == "message" && /firework/i.test(messageText)) {
        return true;
      }
      return false;
    },
    ref: fireworksEffectRef,
    callback: () => { }
  },
  {
    applicable: (msg: SystemMessageData | ChatMessageData) => {
      const messageText = (msg as ChatMessageData)?.translations?.en + " " + msg.message;
      if (msg.type == "message" && /meteor/i.test(messageText)) {
        return true;
      }
      return false;
    },
    ref: meteorEffectRef,
    callback: () => { }
  },
  {
    applicable: (msg: SystemMessageData | ChatMessageData) => {
      const messageText = (msg as ChatMessageData)?.translations?.en + " " + msg.message;
      if (msg.type == "message" && /congrats|birthday|congratulation/i.test(messageText)) {
        return true;
      }
      return false;
    },
    ref: confettiEffectRef,
    callback: () => { }
  }];

  const actions = {
    sendMessage: (type: string, to: string, message: string) => {
      alert(`This will send message: ${message} of type: ${type} to a user: ${to}.`);
    },
    broadcast: (type: string, message: string) => {
      alert(`This will broadcast the message: ${message} of type: ${type}.`);
    }
  };

  useEffect(() => {
    if (!isReady) {
      roomId && messages.length && setLastSeenMessageId(roomId, messages[0].timestamp);
      return;
    }
    const newSystemMessages = (messages as (DisplayMessage | SystemMessageData)[]).filter(
      (msg) => lastSeenMessageId && msg.timestamp > lastSeenMessageId && msg.type == "system"
    );

    for (const msg of newSystemMessages.reverse()) {
      for (const widget of widgetsList) {
        if (widget.applicable(msg)) {
          widget.ref.current?.onMessage({ message: msg });
          // break;
        }
      }
      roomId && setLastSeenMessageId(roomId, msg.timestamp);
    }
  }, [messages]);

  useEffect(() => {
    if (!translatedMessage) {
      return
    }
    for (const widget of widgetsList) {
      if (widget.applicable(translatedMessage)) {
        widget.ref.current?.onMessage({ message: translatedMessage });
      }
    }
  }, [translatedMessage]);

  return (<div className={
    cn("absolute left-0 bottom-[137px] right-0",
      isPresentationMode ? "top-[47px] bottom-[70px]" : "top-[85px] md:top-[125px]"
    )
  }
    ref={widgetTargetRef}>
    <FireworksComponent ref={fireworksEffectRef} targetRef={widgetTargetRef} isFullscreen={isFullscreen} actions={actions} />
    <MeteorShowerCanvas ref={meteorEffectRef} targetRef={widgetTargetRef} isFullscreen={isFullscreen} actions={actions} />
    <ConfettiCanvas ref={confettiEffectRef} targetRef={widgetTargetRef} isFullscreen={isFullscreen} actions={actions} />
  </div>
  );
};
